export default __webpack_public_path__ + "static/media/seenWith.b9c188a6.svg";